<template>
  <q-scroll-area
    ref="scrollAreaRef"
    class="san-page-app--scrollarea"
    :visible="false"
    :vertical-offset="[header.height, 0]"
    @scroll="onScroll"
  >
    <div class="san-page-app--container">
      <div class="san-page-app--header">
        <div class="heading">
          <div class="icon">
            <q-icon :name="icon" />
          </div>

          <div class="title-caption">
            <h1 class="title">
              {{ title || t('Page.title') }}
            </h1>

            <div
              v-if="caption"
              class="caption"
            >
              {{ caption || t('Page.caption') }}
            </div>
          </div>

          <q-space />

          <div
            v-if="action"
            class="action"
          >
            <SanButton
              icon-start="mono-plus"
              @click="action.onClick"
            >
              {{ action.label }}
            </SanButton>
          </div>
        </div>

        <div class="breadcrumbs column">
          <!-- <div>breadcrumbs</div> -->
        </div>
      </div>

      <div
        v-if="!!$slots['toolbar-left'] || !!$slots['toolbar-right']"
        ref="toolbarRef"
        class="san-page-app--toolbar"
        :class="{ 'is-sticky': isStickyToolbar }"
      >
        <div
          v-if="!!$slots['toolbar-left']"
          class="toolbar-left"
        >
          <q-toolbar>
            <SanTransitionSlide
              is-reverse
              is-width="auto"
              :is-continuous="false"
            >
              <q-toolbar-title
                v-show="isStickyToolbar"
                ref="toolbarTitleRef"
              >
                <span>{{ t('Page.menu.label') }}</span>
              </q-toolbar-title>
            </SanTransitionSlide>

            <slot name="toolbar-left">
              Left Toolbar
            </slot>
          </q-toolbar>
        </div>

        <div
          v-if="!!$slots['toolbar-right']"
          class="toolbar-right"
        >
          <q-toolbar>
            <slot name="toolbar-right">
              Right Toolbar
            </slot>
          </q-toolbar>
        </div>

        <div
          v-if="!!$slots['toolbar-under']"
          class="toolbar-under"
        >
          <q-toolbar>
            <slot name="toolbar-under">
              Under Toolbar
            </slot>
          </q-toolbar>
        </div>

        <div class="toolbar-shadow" />
      </div>

      <div
        v-if="!!$slots['body']"
        class="san-page-app--body"
      >
        <slot name="body">
          <p
            v-for="i of 50"
            :key="i"
          >
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Necessitatibus magnam sit
            excepturi harum qui velit, reiciendis, earum veritatis autem voluptatem iusto non vel
            eaque tempore ducimus omnis cupiditate. Ratione, placeat.
          </p>
        </slot>
      </div>
    </div>
  </q-scroll-area>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, onBeforeUnmount } from 'vue' // eslint-disable-line
import { useRoute } from 'vue-router'
import { dom } from 'quasar'
import { useMainHeader } from '@/composables'
import { useGlobalStore } from '@/stores'
import { useTranslation } from 'i18next-vue'
import { storeToRefs } from 'pinia'
import SanButtonBack from '@/components/buttons/SanButtonBack.vue' // eslint-disable-line

const props = defineProps({
  title: { type: String, default: null },
  caption: { type: String, default: null },
  action: { type: Object, default: null },
  prevPage: { type: Object, default: () => ({}) }
})

const $route = useRoute()
const { t } = useTranslation($route.meta.namespace)
const { offset } = dom // eslint-disable-line
const { setHeaderComponent, clearHeaderComponent } = useMainHeader() // eslint-disable-line
const { header } = storeToRefs(useGlobalStore())

const scrollAreaRef = ref(null)
const toolbarRef = ref(null)
const toolbarTitleRef = ref(null)
const isStickyToolbar = ref(false)

const onScroll = ({ verticalPosition, horizontalPosition, ...f }) => {
  header.value.scrollPosition = verticalPosition
  header.value.isScrolled = verticalPosition > 0
  isStickyToolbar.value = toolbarRef.value ? offset(toolbarRef.value).top === header.value.height : false
}

const icon = computed(() => $route.meta.icon)
const title = computed(() => props.title)
const caption = computed(() => props.caption)

// onMounted(() => setHeaderComponent(SanButtonBack, { toPageTitle: props.prevPage?.title }))
// onBeforeUnmount(clearHeaderComponent)

onUnmounted(() => {
  header.value.isScrolled = false
  header.value.scrollPosition = 0
})

defineExpose({ scrollAreaRef })
</script>
